<template>
    <!-- 选对小工具-金额 -->
  <div class="xd-money">
      <div class="header-bg">
          <h5>我的资产(元)</h5>
          <img src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/xd_money_bg.png" alt="">
      </div>
      
      <!-- content -->
      <div class="main">
          <div class="top">
              <div class="child">
                  <h4>2000</h4>
                  <p>本月收益(元)</p>
              </div>
              <div class="child">
                  <h4>2000</h4>
                  <p>历史累计收入(元)</p>
              </div>
          </div>
          <div class="bottom">
              <div class="list">
                <img src="https://themes-cdn.xjy.cn/statics/career/images/xuandui_gadgets/xd_money_bg.png" alt="">
                <span class="title">黄彦文</span>
                <span class="date">2020.5.6 15:35</span>
                <span class="money">+199</span>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import { counsellingList } from "@/api/xuandui_gadgets"
import { shareCon } from "@/utils/wxconfig";
export default {
    data(){
        return{
            list:[],
            pages:{
                page: 1,
                size: 10,
            },
        }
    },
    methods:{
        // 初始化获取数据
        pullData(){
            //调用加载中
            this.$emit('loadingHandle',true,"拼命加载中...");
            let q = this.$route.query;
            let obj = {
                page:this.pages.page,  //页码，默认1
                size:this.pages.size,   //每页数量，默认10
                category_id:2,//做自己节传1,选对小工具传2
                status:1
            };
            counsellingList(obj).then((data)=>{
                    //关闭加载中
                this.$emit('loadingHandle',false);
                if(data.error>0){
                    this.$toast(data.detail || data.msg);
                    return
                }
                this.pages = data.pager;
                
                this.list = data.list;
                

                document.title = '金额';

            });

            

            shareCon('index',this);
        }
    },
    created(){
        this.pullData();
    }
}
</script>

<style lang="scss" scoped>
.xd-money{
    .header-bg{
        position: relative;
        width: 100%;
        height: 286px;
        text-align: center;
        padding-top: 120px;
        h5{
            font-size: 32px;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 44px;
        }
        img{
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: -1;
        }
    }
    .main{
        position: relative;
        .top{
            width: 690px;
            height: 200px;
            background: #FFFFFF;
            border-radius: 20px;
            display: flex;
            align-items: center;
            margin: -70px auto 20px;
            .child{
                flex:1;
                text-align: center;
                h4{
                    font-size: 48px;
                    font-weight: 500;
                    color: #2B333A;
                    line-height: 66px;
                }
                p{
                    font-size: 26px;
                    font-weight: 400;
                    color: #7F848B;
                    line-height: 36px;
                }
            }
        }
        .bottom{
            width: 690px;
            background: #FFFFFF;
            border-radius: 20px;
            margin: 0 auto;
            .list{
                line-height: 98px;
                display: flex;
                align-items: center;
                padding: 30px;
                img{
                    width: 72px;
                    height: 72px;
                    border-radius: 50%;
                }
                .title{
                    font-size: 30px;
                    font-weight: 400;
                    color: #2B333A;
                    line-height: 42px;
                    margin-left: 10px;
                }
                .date{
                    font-size: 26px;
                    font-weight: 400;
                    color: #A9AFB3;
                    margin-left: 20px;
                }
                .money{
                    margin-left: auto;
                    font-size: 30px;
                    font-weight: 400;
                    color: #FF0000;
                }
            }
        }
    }
}
</style>